import { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';

const GroupNode = ({ id, data, selected }) => {
    const [editing, setEditing] = useState(false);
    const [draftName, setDraftName] = useState(data?.label || data?.nodeName || '');
    const inputRef = useRef(null);
    const currentName = data?.label || data?.nodeName || '';
    const interactionLocked = !!data?.interactionLocked;
    const readOnlyView = !!data?.readOnlyView;
    const editable = !interactionLocked && !readOnlyView;

    useEffect(() => {
        if (!editing) {
            setDraftName(currentName);
        }
    }, [currentName, editing]);

    useEffect(() => {
        if (editing) {
            inputRef.current?.focus?.();
            inputRef.current?.select?.();
        }
    }, [editing]);

    useEffect(() => {
        if (editable) return;
        setEditing(false);
        setDraftName(currentName);
    }, [currentName, editable]);

    const submitName = () => {
        if (!editable) {
            setEditing(false);
            setDraftName(currentName);
            return;
        }
        const nextName = (draftName || '').trim() || currentName || '组';
        setEditing(false);
        if (nextName === currentName) return;
        data?.onChange?.(id, {
            label: nextName,
        });
    };

    return (
        <div className={`${styles.wrapper} ${selected ? styles.wrapperSelected : ''}`}>
            <div className={`${styles.label} nodrag nopan`}>
                {editing ? (
                    <input
                        ref={inputRef}
                        type="text"
                        value={draftName}
                        className={styles.labelInput}
                        maxLength={50}
                        onChange={(event) => setDraftName(event.target.value)}
                        onBlur={submitName}
                        onMouseDown={(event) => event.stopPropagation()}
                        onClick={(event) => event.stopPropagation()}
                        onKeyDown={(event) => {
                            event.stopPropagation();
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                submitName();
                            }
                            if (event.key === 'Escape') {
                                event.preventDefault();
                                setDraftName(currentName);
                                setEditing(false);
                            }
                        }}
                    />
                ) : (
                    <button
                        type="button"
                        className={styles.labelButton}
                        onClick={(event) => {
                            event.stopPropagation();
                            if (!editable) return;
                            setEditing(true);
                        }}
                    >
                        {currentName || '组'}
                    </button>
                )}
            </div>
        </div>
    );
};

export default GroupNode;
